import React, { useEffect, useState } from 'react';
import { Menu } from 'lucide-react';
import { Button } from './Button';
import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle } from './Sheet';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = ['Home', 'About', 'Listings', 'Services', 'Contact'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-charcoal py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-105">
      <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-106">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 z-50" data-id="element-107">
          <img src="https://cdn.magicpatterns.com/uploads/nTXeUnc9Lw2NVzZWLxEVDq/Rance-Realty-Demo-logo.png" alt="Rance Realty Logo" className={`transition-all duration-300 ${isScrolled ? 'h-10' : 'h-12'} brightness-0 invert`} data-id="element-108" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-109">
          {navLinks.map(link => <a key={link} href={`#${link.toLowerCase()}`} className="text-white font-body text-sm uppercase tracking-wider hover:text-gold transition-colors" data-id="element-110">
              {link}
            </a>)}
          <Button className="bg-gold hover:bg-gold-dark text-charcoal font-semibold rounded-none px-6 h-12" data-id="element-111">
            View Listings
          </Button>
        </nav>

        {/* Mobile Nav */}
        <div className="md:hidden" data-id="element-112">
          <Sheet data-id="element-113">
            <SheetTrigger asChild data-id="element-114">
              <Button variant="ghost" size="icon" className="text-white hover:bg-white/10" data-id="element-115">
                <Menu className="h-6 w-6" data-id="element-116" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-charcoal border-l-charcoal text-white pt-16" data-id="element-117">
              <SheetHeader className="hidden" data-id="element-118">
                <SheetTitle data-id="element-119">Menu</SheetTitle>
              </SheetHeader>
              <nav className="flex flex-col gap-6" data-id="element-120">
                {navLinks.map(link => <a key={link} href={`#${link.toLowerCase()}`} className="text-white font-heading text-xl uppercase tracking-widest hover:text-gold transition-colors" data-id="element-121">
                    {link}
                  </a>)}
                <Button className="bg-gold hover:bg-gold-dark text-charcoal font-semibold rounded-none w-full h-14 mt-4 text-lg" data-id="element-122">
                  View Listings
                </Button>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>;
}